import { toast } from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";

import {
    requestSendEmail,
    requestGetEmployeeEmails
} from "api/menu/email-blaster/requests";

export const LOADING_EMAIL_BLASTER = "LOADING_EMAIL_BLASTER";
export const EMAIL_BLASTER_GET_EMPLOYEE_EMAILS = "EMAIL_BLASTER_GET_EMPLOYEE_EMAILS";
export const ERROR_EMAIL_BLASTER = "ERROR_EMAIL_BLASTER";

export const setLoading = (status) => ({
    type: LOADING_EMAIL_BLASTER,
    payload: status
});

export const fetchEmployeeEmails = (jobId, dateFrom, dateTo) => dispatch => {
    dispatch(setLoading(true));
    requestGetEmployeeEmails(jobId, dateFrom, dateTo)
        .then(response => {
            dispatch({
                type: EMAIL_BLASTER_GET_EMPLOYEE_EMAILS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, ERROR_EMAIL_BLASTER));
        });
};

export const sendEmail = (data, callback) => dispatch => {
    dispatch(setLoading(true));
    requestSendEmail(data)
        .then(() => {
            toast("Email sent successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, ERROR_EMAIL_BLASTER));
        });
};
